__turbopack_context__.v({
  "actionButton": "LeadList-module__zg-ihq__actionButton",
  "actionsColumn": "LeadList-module__zg-ihq__actionsColumn",
  "avatar": "LeadList-module__zg-ihq__avatar",
  "avatarColumn": "LeadList-module__zg-ihq__avatarColumn",
  "company": "LeadList-module__zg-ihq__company",
  "container": "LeadList-module__zg-ihq__container",
  "date": "LeadList-module__zg-ihq__date",
  "dateColumn": "LeadList-module__zg-ihq__dateColumn",
  "disabled": "LeadList-module__zg-ihq__disabled",
  "divider": "LeadList-module__zg-ihq__divider",
  "emptyState": "LeadList-module__zg-ihq__emptyState",
  "floatColumn": "LeadList-module__zg-ihq__floatColumn",
  "floatText": "LeadList-module__zg-ihq__floatText",
  "interactionColumn": "LeadList-module__zg-ihq__interactionColumn",
  "interactionText": "LeadList-module__zg-ihq__interactionText",
  "list": "LeadList-module__zg-ihq__list",
  "name": "LeadList-module__zg-ihq__name",
  "nameColumn": "LeadList-module__zg-ihq__nameColumn",
  "row": "LeadList-module__zg-ihq__row",
  "showAllContainer": "LeadList-module__zg-ihq__showAllContainer",
  "showAllLink": "LeadList-module__zg-ihq__showAllLink",
});
